<template>
  <div class="card col-xl-12 col-lg-12">
    <div class="card-header card-header-flex flex-column">
      <a-tabs
        class="kit-tabs"
        :default-active-key="activeKey"
        @change="callback"
      >
        <a-tab-pane :tab="this.$t('scolarite.modules')" key="1" />
        <a-tab-pane :tab="this.$t('scolarite.modulesSpec')" key="2" />
        <a-tab-pane :tab="this.$t('scolarite.modulesVerySpec')" key="3" />
        <a-tab-pane :tab="this.$t('scolarite.affichageParametrage')" key="4" />
        <a-tab-pane :tab="this.$t('scolarite.certification')" key="5" />
        <a-tab-pane :tab="this.$t('scolarite.appreciation')" key="6" />
        <a-tab-pane :tab="this.$t('decisionConseil.decisionConseil')" key="7" />
        <a-tab-pane :tab="this.$t('bulletin.bulletinCoefs')" key="8" />
      </a-tabs>
    </div>
    <div class="card-body">
      <keep-alive>
        <component v-bind:is="currentTabComponent" :key="loadKey"></component>
      </keep-alive>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import modules from "./components/modules";
import moduleSpecifique from "./components/moduleSpecifique";
import moduleVerySpecific from "./components/moduleVerySpecific";
import certification from "./components/certification";
import appreciation from "./components/appreciation";
import affichageParametrage from "./components/affichageParametrage";
import decisionConseil from "./components/decisionConseil";
import bulletinCoef from "./components/bulletinCoef";

export default {
  name: "etablissement",
  components: {
    modules,
    moduleSpecifique,
    moduleVerySpecific,
    certification,
    appreciation,
    affichageParametrage,
    decisionConseil,
    bulletinCoef,
  },
  data() {
    return {
      activeKey: "1",
      loadKey: 0,
    };
  },
  computed: {
    currentTabComponent: function () {
      switch (this.activeKey) {
        case "1":
          return "modules";
        case "2":
          return "moduleSpecifique";
        case "3":
          return "moduleVerySpecific";
        case "4":
          return "affichageParametrage";
        case "5":
          return "certification";
        case "6":
          return "appreciation";
        case "7":
          return "decisionConseil";
        case "8":
          return "bulletinCoef";
      }
    },
  },
  methods: {
    callback: function (key) {
      this.activeKey = key;
      this.loadKey += 1;
    },
  },
};
</script>

<style scoped>
::v-deep .ant-tabs-nav-wrap {
  overflow: hidden !important;
}
</style>
